module.exports = __webpack_public_path__ + "img/greenpoint.bfe88012.png";